import Swiper, { Autoplay, Navigation } from "swiper";
import ScrollMagic from "scrollmagic";

const $ = jQuery;

$(document).ready(function () {
  // /* SLIDER ONHOME */
  const swiper = new Swiper(".swiper", {
    modules: [Autoplay, Navigation],
    // Optional parameters
    loop: true,
    autoplay: true,
    slidesPerView: 1,
    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      576: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
    },
  });

  /* NAV */
  $(".nav__toggle").on("click", function (e) {
    let $nav;
    e.preventDefault();
    $(this).toggleClass("active");
    $nav = $($(this).data("target"));
    if ($nav.hasClass("active")) {
      $nav.removeClass("active");
      $nav.velocity("slideUp", {
        duration: 250,
      });
    } else {
      $nav.addClass("active");
      $nav.velocity("slideDown", {
        duration: 250,
        display: "flex",
      });
    }
    return false;
  });

  /* STICKY CTA TOGGLE */
  $(".cta-sticky__toggle, .cta-sticky__close").on("click", function (e) {
    const $content = $(this)
      .parents(".cta-sticky")
      .find(".cta-sticky__content__wrapper");
    $content.toggleClass("open");
    let translateValue = $content.hasClass("open") ? [0, "100%"] : ["100%", 0];
    $content.velocity({
      translateX: translateValue,
      duration: 350,
    });
  });
  /* fade sticky cta out */
  const controller = new ScrollMagic.Controller();
  // build scene
  const scene = new ScrollMagic.Scene({
    triggerElement: "#cta-sticky__trigger",
  })
    // trigger a velocity opaticy animation
    .on("leave", function (event) {
      $(".cta-sticky").velocity("fadeIn", { duration: 400 });
    })
    .on("enter", function (event) {
      $(".cta-sticky").velocity("fadeOut", { duration: 400 });
    })
    //.addIndicators() // add indicators (requires plugin)
    .addTo(controller);

  /* LANGUAGE TOGGLE */
  $(".language-switch__toggle").on("click", function (e) {
    let $parent, $list;
    e.preventDefault();
    $parent = $(this).parent();
    $list = $parent.find(".wpml-ls-legacy-list-vertical");
    $(this).toggleClass("active");
    if ($parent.hasClass("active")) {
      $parent.removeClass("active");
      $list.velocity("slideUp", {
        duration: 150,
      });
    } else {
      $parent.addClass("active");
      $list.velocity("slideDown", {
        duration: 150,
      });
    }
    return false;
  });

  /* ARCIVE ACCRDIONS */
  if ($(".archive__accordion__toggle").length > 0) {
    $(".archive__accordion__toggle").on("click", function (e) {
      let $inner_accordions;
      let $next;
      let $parent;
      let was_open;
      e.preventDefault();
      $next = $(this).next();
      was_open = $(this).hasClass("open");
      $(".archive__accordion__toggle").removeClass("open");
      if (!was_open) {
        $(this).toggleClass("open");
      }
      if ($next.hasClass("show")) {
        $next.removeClass("show");
        return $next.slideUp(350);
      } else {
        $parent = $(this).parent().parent();
        $inner_accordions = $parent.find("li .archive__accordion__inner");
        $inner_accordions.removeClass("show");
        $inner_accordions.slideUp(350);
        $next.toggleClass("show");
        return $next.slideToggle(350);
      }
    });
    let date = new Date(Date.now());
    let year_str = date.getFullYear();
    let month_str = date.getMonth() + 1;
    $(
      "[data-date='" +
        year_str +
        "'], [data-date='" +
        year_str +
        "-" +
        month_str +
        "']"
    ).trigger("click");
  }
});
